import { render, staticRenderFns } from "./AtcProofofReturn.vue?vue&type=template&id=75233836&"
import script from "./AtcProofofReturn.vue?vue&type=script&lang=js&"
export * from "./AtcProofofReturn.vue?vue&type=script&lang=js&"
import style0 from "./AtcProofofReturn.vue?vue&type=style&index=0&id=75233836&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports